import jsonPointer from 'json-pointer';

function injectProperties(parsedRef) {
  return parsedRef.reduce((a, segment) => [...a, 'properties', segment], []);
}

function replaceArrayIndexes(parsedRef) {
  return parsedRef.replace(/\[([0-9]+)\]/gi, '/$1');
}

export default function createRef($ref, parentRef) {
  if ($ref === '') {
    return $ref;
  }

  let parsedRef = $ref;
  const parsedParentRef = parentRef != null ? jsonPointer.parse(parentRef) : [];

  if (typeof parsedRef === 'string') {
    if (parsedRef.indexOf('.') > -1 || parsedRef.indexOf(',') > -1) {
      parsedRef = injectProperties(parsedRef.split(/[.,]/));
    } else {
      parsedRef = parsedRef.replace(/^#?(.*)/, '$1');
      parsedRef = parsedRef.charAt(0) === '/' ? jsonPointer.parse(parsedRef) : [parsedRef];
    }

    if (parsedRef[0] !== $ref) {
      return replaceArrayIndexes(jsonPointer.compile([...parsedParentRef, ...parsedRef]));
    }
  }

  if (Array.isArray(parsedRef)) {
    parsedRef = injectProperties(parsedRef);

    return replaceArrayIndexes(jsonPointer.compile([...parsedParentRef, ...parsedRef]));
  }

  return '';
}
